import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import routes from './routes';
import LandingPage from './components/landing-page';
import CompanyPage from './components/company-page';
import DocumentPage from './components/document-page';

const App = () => {
  const [environmentName, setEnvironmentName] = useState();

  useEffect(() => {
    fetch('/api/environment/name')
      .then(response => {
        if (!response.ok) return;
        return response.text();
      })
      .then(name => {
        setEnvironmentName(name);
      })
      .catch(() => {
        // Silently ignore — environment check is non-critical
      });
  }, []);

  const isTest = environmentName === 'Development';
  const isProduction = environmentName === 'Production';

  return (
      <div className={`app-wrapper ${isTest ? 'env-test' : ''}`}>
      <BrowserRouter>
        <Switch>
          <Route exact path={routes.home} component={LandingPage} />
          <Route
            exact
            path={routes.company}
            render={() => <CompanyPage isProduction={isProduction} />}
          />
          <Route path={routes.document} component={DocumentPage} />
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default App;
